import "../components/styles.css";
import React from "react";
import CalendarPicker from "../components/calendar-picker";

export default function Days({
  onSelectedDateFrom,
  dateFrom,
  onSelectedDateTo,
  dateTo,
  canSelectPast,
}) {
  return (
    <>
      <CalendarPicker
        label={"From"}
        isStanAlone
        onSelected={(value, str) => onSelectedDateFrom(value, str)}
        value={dateFrom}
        isDisablePast={!canSelectPast}
        id="days-calendar-from-component"
      />
      <CalendarPicker
        label={"To"}
        isStanAlone
        onSelected={(value, str) => onSelectedDateTo(value, str)}
        value={dateTo}
        isDisablePast={!canSelectPast}
        id="days-calendar-to-component"
      />
    </>
  );
}
